

function authHeader() {
  const token = localStorage.getItem("token");  
 
    if (token) {
        return { Authorization: 'Bearer ' + token };       // for Node.js Express back-end
    } else {
      return {};
    }
}



export default {
  authHeader
};